import type { ReceiveResult } from '@chukua/common';
import { CircleCheck } from 'lucide-react';

/** A truck that is already received: when, the readings it was received with, and the work orders its defects raised. */
export function ReceivedSummary({ received }: { received: ReceiveResult }) {
  return (
    <section aria-labelledby="received-heading" className="rounded-xl border border-success/40 bg-success/10 p-4">
      <h2 id="received-heading" className="flex items-center gap-2 text-base font-semibold text-fg">
        <CircleCheck className="size-5 text-success" aria-hidden />
        Received at the yard
      </h2>
      <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
        <dt className="text-muted">Arrived</dt>
        <dd className="text-fg">{new Date(received.receivedAt).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}</dd>
        <dt className="text-muted">Odometer</dt>
        <dd className="text-fg">{received.odometerKm.toLocaleString()} km</dd>
        <dt className="text-muted">Fuel gauge</dt>
        <dd className="text-fg">{received.fuelLevelPercent}%</dd>
      </dl>
      {received.workOrders.length > 0 && (
        <ul className="mt-3 flex flex-col gap-1 border-t border-success/30 pt-3 text-sm text-fg">
          {received.workOrders.map((order) => (
            <li key={order.id}>
              WO-{order.sequenceNumber} · {order.title}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
